import React from "react"
import { Label } from "semantic-ui-react"
import PartnerImage from "./images/YGR-Partner-Stamp.png"

const SIZE = "small"

export const CyclistOwned = ({ company }) => {
  if (!company.cyclist_owned) return null
  return (
    <Label basic size={SIZE} icon="bicycle" content="Cyclist Owned" className="company-badge" />
  )
}

export const YGRPartner = ({ company }) => {
  if (!company.ygr_partner) return null
  return (
    <Label size={SIZE} image className="company-badge">
      <img src={PartnerImage} alt="YRG Partner" />
    </Label>
  )
}

export const LeagueOfCyclists = ({ company }) => {
  if (!company.league_of_cyclists) return null
  return (
    <a href="https://www.bikeleague.org" target="_blank" rel="noopener noreferrer">
      <Label
        basic
        size="tiny"
        icon="bicycle"
        content="League of Bicyclists"
        className="company-badge"
      />
    </a>
  )
}
